var map = {
	"./Abhinav/images/Logo.svg": [
		24903,
		7284
	],
	"./Agrasen/images/Logo.svg": [
		46488,
		6488
	],
	"./Bhagini/images/Logo.svg": [
		47627,
		7627
	],
	"./Deogiri/images/Logo.svg": [
		52348,
		2348
	],
	"./JCOM/images/Logo.svg": [
		44738,
		4738
	],
	"./MOGAVEERA/images/Logo.svg": [
		68764,
		8764
	],
	"./Mahesh/images/Logo.svg": [
		51269,
		1269
	],
	"./NCBM/images/Logo.svg": [
		44005,
		4005
	],
	"./Noble/images/Logo.svg": [
		19219,
		9219
	],
	"./RSSB/images/Logo.svg": [
		98969,
		8969
	],
	"./Samta/images/Logo.svg": [
		22967,
		2967
	],
	"./Satara/images/Logo.svg": [
		84409,
		4409
	],
	"./Sawji/images/Logo.svg": [
		15971,
		5971
	],
	"./Shriraksh/images/Logo.svg": [
		80422,
		422
	],
	"./Suvarna/images/Logo.svg": [
		10211,
		211
	],
	"./Ucob/images/Logo.svg": [
		19380,
		9380
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 15897;
module.exports = webpackAsyncContext;